<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved 
-->
<template>
  <div class="container layout extra-css">
    <div class="row">
      <div class="col-lg-7 col-xl-8" v-if="!isBE">
        <!-- Breadcrumb -->

        <ul class="breadcrumb" itemscope itemtype="http://schema.org/BreadcrumbList">
          <li
            class="breadcrumb__item"
            itemprop="itemListElement"
            itemscope
            itemtype="http://schema.org/ListItem"
          >
            <a
              :href="homelink"
              class="breadcrumb__link"
              itemscope
              itemtype="http://schema.org/Thing"
              itemprop="item"
            >{{ strings.home }}</a>
            <meta itemprop="position" content="1" />
          </li>
          <li
            class="breadcrumb__item"
            itemprop="itemListElement"
            itemscope
            itemtype="http://schema.org/ListItem"
          >
            <a
              :href="venueInfo.breadcrumb"
              class="breadcrumb__link"
              itemscope
              itemtype="http://schema.org/Thing"
              itemprop="item"
            >{{ venueInfo.city }}</a>
            <meta itemprop="position" content="2" />
          </li>
        </ul>

        <!-- Title -->

        <img
          v-if="bergIconShouldShow"
          id="berg_icon"
          src="https://meetingpackage.com/sites/default/files/berghansen_2018.png"
        />

        <h1>{{ venueInfo.title }}</h1>

        <!-- Venue meta information -->

        <ul class="inline-list">
          <li v-if="!isBE" class="inline-list__item">{{ venueInfo.venue_type }}</li>
          <li v-if="!isBE" class="inline-list__item">
            <a
              href
              v-scroll-to="'#address'"
              class="inline-list__link js-smooth-scroll"
            >{{ venueInfo.full_address }}</a>
          </li>
        </ul>

        <!--<MPBusinessHours />-->

        <!-- Description -->
        <div v-if="!isBE">
          <h4>{{ strings.description }}</h4>
          <MPVenueDescription :description="_venueDescription" :strings="strings" />
        </div>

        <!-- Package choice -->
        <div id="showingRoomPackage"></div>
        <MPPackageList v-if="currentTab == 'package'" />

        <!-- Room choice -->

        <MPRoomList v-if="currentTab == 'room' && !isRegus" />
        <RegusRoomList v-if="currentTab == 'room' && isRegus" />

        <!-- Room choice in Package-->

        <MPRoomListinPackage v-if="currentTab == 'package' && !roomShouldHide && !isRegus" />

        <!-- Covid-19 safety regulation -->
        <CapacityNotification />

        <!-- Venue details -->
        <h3 v-if="isNCH">{{ strings.hoteldetails}}</h3>

        <p v-if="isNCH" class="small">{{ strings.nchEquipText }}.</p>

        <div v-if="!isDavinci">
          <h4
            v-if="venueInfo.venue_facilities && venueInfo.venue_facilities.length > 0"
          >{{ strings.facilities }}</h4>
          <MPFacilities
            :facilities="venueInfo.facilities"
            :venuefacilities="venueInfo.venue_facilities"
          />

          <h4
            v-if="venueInfo.venue_environment && venueInfo.venue_environment.length > 0"
          >{{ isNCH ? strings.location : strings.environment }}</h4>
          <MPEnvironment
            :environment="venueInfo.environment"
            :venueenvironment="venueInfo.venue_environment"
          />

          <h4
            v-if="venueInfo.venue_sports && venueInfo.venue_sports.length > 0"
          >{{ isNCH ? strings.gymandrelax : strings.sports }}</h4>
          <MPSports :sports="venueInfo.sports" :venuesports="venueInfo.venue_sports" />

          <h4
            v-if="venueInfo.venue_services && venueInfo.venue_services.length > 0"
          >{{ strings.additionalservices }}</h4>
          <MPServices :services="venueInfo.services" :venueservices="venueInfo.venue_services" />
        </div>

        <!-- Description -->
        <div v-if="isBE">
          <h4>{{ strings.description }}</h4>
          <MPVenueDescription :description="_venueDescription" :strings="strings" />
        </div>

        <!-- Venue location -->

        <MPLocation :strings="strings" :fulladdress="venueInfo.full_address" />

        <!-- Similar venues -->
        <MPSimilarVenues v-if="displaySimilarVenues" :strings="strings" :venueInfo="venueInfo" />
      </div>

      <div class="col-lg-12 col-xl-12 isBE" v-if="isBE">
        <MPNewHorizontalFloatingForm :lang="selectedLang" v-if="isBE && useNewVenuePage" />
        <MPHorizontalFloatingForm :lang="selectedLang" v-if="isBE && !useNewVenuePage" />

        <!-- Breadcrumb -->
        <MPDiscountCodeErrorBlock v-if="isBE" />
        <ul class="breadcrumb" itemscope itemtype="http://schema.org/BreadcrumbList" :style="{'visibility': useNewVenuePage ? '' : 'hidden'}">
          <li
            class="breadcrumb__item"
            itemprop="itemListElement"
            itemscope
            itemtype="http://schema.org/ListItem"
          >
            <a
              :href="homelink"
              class="breadcrumb__link"
              itemscope
              itemtype="http://schema.org/Thing"
              itemprop="item"
            >{{ strings.home }}</a>
            <meta itemprop="position" content="1" />
          </li>
          <li
            class="breadcrumb__item"
            itemprop="itemListElement"
            itemscope
            itemtype="http://schema.org/ListItem"
          >
            <a
              :href="searchPageLink"
              class="breadcrumb__link"
              itemscope
              itemtype="http://schema.org/Thing"
              itemprop="item"
            >{{ venueInfo.city }}</a>
            <meta itemprop="position" content="2" />
          </li>
        </ul>

        <!-- Title -->

        <img
          v-if="bergIconShouldShow"
          id="berg_icon"
          src="https://meetingpackage.com/sites/default/files/berghansen_2018.png"
        />

        <h1>{{ venueInfo.title }}</h1>

        <!-- Venue meta information -->

        <ul class="inline-list">
          <li v-if="!isBE" class="inline-list__item">{{ venueInfo.venue_type }}</li>
          <li v-if="!isBE" class="inline-list__item">
            <a
              href
              v-scroll-to="'#address'"
              class="inline-list__link js-smooth-scroll"
            >{{ venueInfo.full_address }}</a>
          </li>
        </ul>

        <!--<MPBusinessHours />-->

        <!-- Description -->
        <div v-if="!isBE">
          <h4>{{ strings.description }}</h4>
          <MPVenueDescription :description="_venueDescription" :strings="strings" />
        </div>

        <div id="showingRoomPackage"></div>
        <MPDayTabList v-if="isMoreThanOneDay" />

        <div v-if="!isMoreThanOneDay">
          <!-- Package choice -->
          <MPPackageList v-if="currentTab == 'package'" />

          <!-- Room choice -->

          <MPRoomList v-if="currentTab == 'room' && !isRegus" />
          <RegusRoomList v-if="currentTab == 'room' && isRegus" />

          <!-- Room choice in Package-->

          <MPRoomListinPackage v-if="!isOpera && currentTab == 'package' && !roomShouldHide" />
        </div>

        <!-- Covid-19 safety regulation -->
        <CapacityNotification />

        <!-- Venue details -->
        <h3 v-if="isNCH">{{ strings.hoteldetails}}</h3>

        <p v-if="isNCH" class="small">{{ strings.nchEquipText }}.</p>

        <div v-if="!isDavinci">
          <h4
            v-if="venueInfo.venue_facilities && venueInfo.venue_facilities.length > 0"
          >{{ strings.facilities }}</h4>
          <MPFacilities
            :facilities="venueInfo.facilities"
            :venuefacilities="venueInfo.venue_facilities"
          />

          <h4
            v-if="venueInfo.venue_environment && venueInfo.venue_environment.length > 0"
          >{{ isNCH ? strings.location : strings.environment }}</h4>
          <MPEnvironment
            :environment="venueInfo.environment"
            :venueenvironment="venueInfo.venue_environment"
          />

          <h4
            v-if="venueInfo.venue_sports && venueInfo.venue_sports.length > 0"
          >{{ isNCH ? strings.gymandrelax : strings.sports }}</h4>
          <MPSports :sports="venueInfo.sports" :venuesports="venueInfo.venue_sports" />

          <h4
            v-if="venueInfo.venue_services && venueInfo.venue_services.length > 0"
          >{{ strings.additionalservices }}</h4>
          <MPServices :services="venueInfo.services" :venueservices="venueInfo.venue_services" />
        </div>

        <!-- Description -->
        <div v-if="isBE">
          <h4>{{ strings.description }}</h4>
          <MPVenueDescription :description="_venueDescription" :strings="strings" />
        </div>

        <!-- Venue location -->

        <MPLocation :strings="strings" :fulladdress="venueInfo.full_address" />

        <!-- Similar venues -->
        <MPSimilarVenues v-if="displaySimilarVenues" :strings="strings" :venueInfo="venueInfo" />
      </div>
      <!-- Aside -->

      <MPFloatingForm :lang="selectedLang" v-if="!isRegus && !isBE" />
      <RegusFloatingForm :lang="selectedLang" v-if="isRegus && !useNewVenuePage" />
      <ModalComponent v-if="showContinueModal" @close="showContinueModal = false">
        <h3 slot="header">{{ strings.continueToCheckout }}</h3>
        <div slot="body">({{ strings.youCanReview }})</div>
        <div slot="footer">
          <button
            class="modal-default-button modal-default-button-cancel"
            @click="createNewDayTab()"
          >{{ strings.addMoreDays}}</button>
          <button
            class="modal-default-button modal-default-button-ok"
            @click="goToCheckout()"
          >{{ strings.continue }}</button>
        </div>
      </ModalComponent>
    </div>
  </div>
</template>

<script>
// Components.
import MPFacilities from "./Facilities";
import MPEnvironment from "./Environment";
import MPSports from "./Sports";
import MPServices from "./Services";
import MPVenueDescription from "./VenueDescription";
import MPLocation from "./Location";
import MPSimilarVenues from "./SimilarVenues";
import MPFloatingForm from "./FloatingForm";
import MPHorizontalFloatingForm from "./HorizontalFloatingForm";
import MPNewHorizontalFloatingForm from "./NewHorizontalFloatingForm";
import MPPackageList from "./PackageList";
import MPRoomList from "./RoomList";
import MPRoomListinPackage from "./RoomListinPackage";
import RegusRoomList from "./RegusRoomList";
import RegusFloatingForm from "./RegusFloatingForm";
import MPDayTabList from "./DayTabList";
import ModalComponent from "./ModalComponent";
//import MPBusinessHours from './BusinessHours';
import MPDiscountCodeErrorBlock from "./DiscountCodeErrorBlock";
import CapacityNotification from './covidCapacity/CapacityNotification.vue'

import CitiesList from '../assets/cities.json'
import moment from 'moment'

export default {
  data() {
    return {
      _venueDescription: "",
      showContinueModal: false,
      useNewSearchPage: window.useNewSearchPage === '1' ? true : false
    };
  },
  computed: {
    isDavinci() {
      return window.isDavinci
    },
    useNewCheckoutPage() {
      return this.$store.state.useNewCheckoutPage;
    },
    isOpera() {
      return this.$store.state.isOpera;
    },
    isNCH() {
      return this.$store.state.isNCH;
    },
    businessHours() {
      return this.$store.state.venueInfo.venue_business_hours;
    },
    finalEvents() {
      return this.$store.state.finalEvents;
    },
    isMoreThanOneDay() {
      return this.$store.state.isMoreThanOneDay;
    },
    strings() {
      return this.$store.state.strings;
    },
    venueInfo() {
      return this.$store.state.venueInfo;
    },
    venueDescription() {
      //return this.$store.state.translatedLanguage
      let lang = this.$store.state.selectedLang;
      return this.$store.state.venueInfo.description2[lang];
    },
    selectedLang() {
      return this.$store.state.selectedLang;
    },
    displaySimilarVenues() {
      return (
        window.location.hostname !== "restel.meetingpackage.com" &&
        window.location.hostname !== "devere.meetingpackage.com" &&
        window.location.hostname !== "meetings.clermonthotel.group" &&
        window.location.hostname !== "meetings.leonardohotels.co.uk"
      );
    },
    currentTab() {
      return this.$store.state.currentTab;
    },
    homelink() {
      let lang = this.$store.state.selectedLang;
      let homelink = "";
      if (lang == "en") {
        homelink = "/";
      } else {
        homelink = "/" + lang;
      }
      return homelink;
    },
    roomShouldHide() {
      return this.$store.state.isPackageFormDisabled;
    },
    isRegus() {
      return this.$store.state.isRegus;
    },
    bergIconShouldShow() {
      if (this.$store.state.venueInfo.hasBHH) {
        return true;
      } else {
        return false;
      }
    },
    isBE() {
      return this.$store.state.isBE;
    },
    useNewVenuePage() {
      return this.$store.state.useNewVenuePage;
    },
    searchPageLink() {
      if (!this.useNewSearchPage) {
        return this.venueInfo.breadcrumb
      }

      // Find destination based on all translations
      const destination = CitiesList.find(city => {
        return Object.keys(city.translations).find(key => city.translations[key] === this.venueInfo.city)
      })
      const datetime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm').unix()
      const endDatetime = moment(this.$store.state.endDatetime, 'DD-MM-YYYY HH:mm').unix()
      const delegates = this.$store.state.delegates
      const discount_code = this.$store.state.discount_code
      let url = this.selectedLang === 'en' ? '' : `/${this.selectedLang}` 
      if (destination) {
        url += `/wl_search?destination=${destination.id}&datetime=${datetime}&end-datetime=${endDatetime}&delegates=${delegates}`
        if (discount_code)
          url += `&discount_code=${discount_code}`
        return url
      }
      return this.venueInfo.breadcrumb
    },
  },
  watch: {
    venueInfo(value) {
      let lang = this.$store.state.selectedLang;
      if (lang == "zh") {
        lang = "zh-hans";
      }
      if (value.default_language) {
        if (
          typeof value.description2[lang] == "undefined" &&
          lang == value.default_language
        ) {
          this._venueDescription = value.description;
        } else if (typeof value.description2[lang] == "undefined") {
          this._venueDescription = "";
        } else {
          this._venueDescription = value.description2[lang];
        }
      } else {
        this._venueDescription = value.description;
      }
    },
    finalEvents(value) {
      if (this.$store.state.finalEvents.length > 0) {
        if (
          this.$store.state.finalEvents.length ==
          this.$store.state.eventList.length
        ) {
          this.showContinueModal = true;
        } else {
          this.showContinueModal = false;
        }
      }
    }
  },
  components: {
    MPVenueDescription,
    MPFacilities,
    MPEnvironment,
    MPSports,
    MPServices,
    MPLocation,
    MPSimilarVenues,
    MPFloatingForm,
    MPHorizontalFloatingForm,
    MPNewHorizontalFloatingForm,
    MPPackageList,
    MPRoomList,
    MPRoomListinPackage,
    RegusRoomList,
    RegusFloatingForm,
    MPDayTabList,
    MPDiscountCodeErrorBlock,
    ModalComponent,
    CapacityNotification
    //MPBusinessHours
  },
  methods: {
    goToCheckout() {
      this.showContinueModal = false;
      if (this.useNewCheckoutPage) {
        this.$store.dispatch("goToCheckout", {});
      } else {
        this.$store.dispatch("goToOperaCheckout", {});
      }
    },
    createNewDayTab() {
      this.showContinueModal = false;
      this.$store.dispatch("createNewDayTab");
    }
  }
};
</script>
<style>
#berg_icon {
  height: 150px;
  float: right;
  margin-top: -40px;
}
.card .tabs {
  display: block !important;
}
.horizontal_discount_block {
  width: 30%;
  float: right;
}
@media (min-width: 639px) {
  .isBE .roomDescription,
  .isBE .packageDescription,
  .isBE .venue-description {
    width: 66%;
    overflow-x: auto;
    word-wrap: break-word;
    line-height: 20px;
  }
}

.isBE .roomDescription,
.isBE .packageDescription,
.isBE .venue-description {
  line-height: 20px;
}

.roomDescription a,
.packageDescription a,
.venue-description a {
  text-decoration: underline !important;
}
</style>

<style scoped>
.modal-default-button-ok,
.modal-default-button-cancel {
  width: 49%;
  cursor: pointer;
}

.modal-header,
.modal-body {
  text-align: center;
}

.modal-default-button-cancel {
  color: #0050FF;
  border-color: #0050FF;
  background-color: transparent;
}

.modal-default-button-cancel:hover {
  color: #fff;
  background-color: #0050FF;
  border-color: #0050FF;
}

.modal-default-button-ok {
  color: #7ed321;
  border-color: #7ed321;
  background-color: transparent;
}

.modal-default-button-ok:hover {
  color: #fff;
  background-color: #7ed321;
  border-color: #7ed321;
}
</style>

